(() => {
  if (window.treviCollectionLoadMore) return;
  window.treviCollectionLoadMore = true;
  document.addEventListener('click', async event => {
    const link = event.target.closest('#Collection-ajaxinate-pagination a[rel="next"]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const grid = document.getElementById('Collection-ajaxinate');
    if (!grid) return;
    event.preventDefault();
    if (link.getAttribute('aria-disabled') === 'true') return;
    const pagination = link.closest('#Collection-ajaxinate-pagination');
    const originalLabel = link.textContent;
    link.setAttribute('aria-disabled', 'true');
    link.textContent = 'Loading…';
    grid.setAttribute('aria-busy', 'true');
    let status = pagination.parentElement.querySelector('[data-load-more-status]');
    if (!status) {
      status = document.createElement('p');
      status.dataset.loadMoreStatus = '';
      status.setAttribute('role', 'status');
      pagination.parentElement.append(status);
    }
    status.textContent = '';
    try {
      const response = await fetch(link.href);
      if (!response.ok) throw new Error('Unable to load products');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = page.getElementById('Collection-ajaxinate');
      const nextPagination = page.getElementById('Collection-ajaxinate-pagination');
      if (!nextGrid || !nextPagination) throw new Error('Missing collection content');
      const products = [...nextGrid.querySelectorAll(':scope > .Grid-item')];
      if (!products.length) throw new Error('No additional products');
      products.forEach(product => grid.append(document.importNode(product, true)));
      pagination.replaceChildren(...[...nextPagination.childNodes].map(node => document.importNode(node, true)));
      status.textContent = `${products.length} more products loaded.`;
      const firstLink = products[0].querySelector('a');
      if (firstLink) grid.children[grid.children.length - products.length].querySelector('a')?.focus({ preventScroll: true });
    } catch (error) {
      link.textContent = originalLabel;
      link.removeAttribute('aria-disabled');
      status.textContent = 'Products could not be loaded. Please try again.';
    } finally {
      grid.removeAttribute('aria-busy');
    }
  });
})();
